module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x640-cbc88b6c1240a254935908730898062e.webp";